var EngravingsFontStyle = "Arial";
var EngravingsFontSize = window.customizeProduct.fontSize;
var EngravingsFontColor = window.customizeProduct.fontColor;
var EngravingsPositionX = window.customizeProduct.textPositionX1;
var EngravingsPositionY = window.customizeProduct.textPositionY1;

window.addToCartCustomize = async function (formElement) {
  var productArray = [];
  let customizeProduct = formElement.elements.customizeProduct;
  let quantity = formElement.elements.quantity;
  if (customizeProduct && customizeProduct.checked) {
    let customizeProductJson = {};
    customizeProductJson["id"] = customizeProduct.getAttribute("data-variant-id");
    customizeProductJson["quantity"] = quantity ? quantity.value : customizeProduct.getAttribute("data-quantity");
    productArray.push(customizeProductJson);
  }

  if (productArray.length <= 0) return;

  const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
    body: JSON.stringify({
      items: productArray,
    }),
    credentials: "same-origin",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
    },
  });

  document.dispatchEvent(new CustomEvent("cart:refresh"));
  return response;
};

function engravingsText(target) {
  let engravingsImages = document.querySelectorAll(".ll-custom-image .EngravingsTextImage");

  for (let i = 0; i < engravingsImages.length; i++) {
    let c = document.createElement("canvas");
    let ctx = c.getContext("2d");
    let w = engravingsImages[i].getAttribute("data-max-width");
    let h = engravingsImages[i].getAttribute("data-max-height");
    c.width = w;
    c.height = h;
    ctx.rect(0, 0, w, h);
    ctx.fillStyle = "#fff";
    ctx.fill();

    let img = new Image();
    img.crossOrigin = "Anonymous"; //解决跨域
    img.src = engravingsImages[i].getAttribute("data-original-src");

    img.onload = function () {
      ctx.drawImage(img, 0, 0, w, h);

      // ctx.rotate(50*Math.PI/180);
      ctx.font = EngravingsFontSize + " " + EngravingsFontStyle;
      ctx.fillStyle = EngravingsFontColor;
      ctx.shadowBlur = 4;
      ctx.shadowColor = EngravingsFontColor;
      ctx.shadowOffsetX = 2;
      ctx.textAlign = "end";

      ctx.fillText(target.value, EngravingsPositionX, EngravingsPositionY);

      let cURL = c.toDataURL("image/jpeg", 0.8);

      engravingsImages[i].src = cURL;
      engravingsImages[i].setAttribute("srcset", cURL);
      engravingsImages[i].setAttribute("data-src", cURL);
    };
  }
}

function closeCustomizeModal() {
  document.getElementById("modal-customize").hide();
}

function applyCustomizeInfo() {
  var value = document.querySelector("[name=properties-customize-text]").value;
  if (value.replace(/(^\s*)|(\s*$)/g, "") != "") {
    setProductFormOptionValue("properties-customize-text");
    document.getElementById("personalise-me").checked = true;
    closeCustomizeModal();
  } else {
    clearCustomizeInfo();
  }
}

function setProductFormOptionValue(optionName) {
  let propertiesFontPosition = document.querySelector("[name=" + optionName + "]");
  document.getElementById(optionName).value = propertiesFontPosition.value;
}

function clearCustomizeInfo() {
  const input = document.querySelector("[name=properties-customize-text]")
  input.value = ""
  document.getElementById("properties-customize-text").value = "";
  document.getElementById("personalise-me").checked = false;

  engravingsText(input)

  closeCustomizeModal();
}
